import { AppError } from './appErrors';

export class AllreadyExistError extends AppError{
    
    return = "Finns redan! (400)"
}